import { lazy, Suspense } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { AnimatePresence } from "framer-motion";

import SpinLoader from "../../components/common/SpinLoader";
import Logout from "../../components/common/Logout";
import ProtectedRoute from "../../components/common/ProtectedRoutes";
import CustomerLayout from "../../components/Customer/CustomerLayout";

const Home = lazy(() => import("../views/Home"));
const NotFound = lazy(() => import("../views/NotFoundPage/NotFoundPage"));
const OtpVerification = lazy(() => import("../views/SignupOtpVerfication"));
const ForgotPassword = lazy(() => import("../views/ForgotPassword"));
const LoginSignup = lazy(() => import("../views/LoginSignup/LoginSignup"));
const ChangePassword = lazy(() => import("../views/ChangePassword"));
const Notifications = lazy(() => import("../views/Notifications"));
const HowItWorks = lazy(() => import("../views/HowItWorks"));
const Dashboard = lazy(() => import("../views/Dashboard"));
const AdvertHistory = lazy(() => import("../views/AdvertHistory"));
const NewAdvert = lazy(() => import("../views/NewAdvert"));
const ProfileUpdate = lazy(() => import("../views/ProfileUpdate"));
const AdvertCallback = lazy(() => import("../views/AdvertCallback"));
const MyProfile = lazy(() => import("../views/MyProfile"));

const BaseRoute = () => {
	const { user, role } = useSelector((state) => state.auth);
	const isAllowed = !!user && role?.toLowerCase() === "customer";
	const location = useLocation();

	return (
		<AnimatePresence
			exitBeforeEnter
			location={location}
			key={location.pathname}
		>
			<Routes>
				<Route
					path="/"
					element={
						<Suspense fallback={<SpinLoader />}>
							<Home />
						</Suspense>
					}
				/>
				<Route path="/logout" element={<Logout />} />
				<Route
					path="/otp-verification"
					element={
						<Suspense fallback={<SpinLoader />}>
							<OtpVerification />
						</Suspense>
					}
				/>
				<Route
					path="/forgot-password"
					element={
						<Suspense fallback={<SpinLoader />}>
							<ForgotPassword />
						</Suspense>
					}
				/>
				<Route
					path="/login"
					element={
						<Suspense fallback={<SpinLoader />}>
							<LoginSignup />
						</Suspense>
					}
				/>
				<Route
					path="/signup"
					element={
						<Suspense fallback={<SpinLoader />}>
							<LoginSignup />
						</Suspense>
					}
				/>
				{/* <Route path="/terms-and-conditions" element={<TermsConditions />} />
				<Route path="/privacy-policy" element={<PrivacyPolicy />} /> */}
				<Route
					path="/how-it-works"
					element={
						<Suspense fallback={<SpinLoader />}>
							<HowItWorks />
						</Suspense>
					}
				/>

				<Route path="/customer" element={<CustomerLayout />}>
					<Route index element={<Navigate to="dashboard" />} />
					<Route
						path="dashboard"
						element={
							<Suspense fallback={<SpinLoader />}>
								<ProtectedRoute isAllowed={isAllowed}>
									<Dashboard />
								</ProtectedRoute>
							</Suspense>
						}
					/>
					<Route
						path="advert-history"
						element={
							<Suspense fallback={<SpinLoader />}>
								<ProtectedRoute isAllowed={isAllowed}>
									<AdvertHistory />
								</ProtectedRoute>
							</Suspense>
						}
					/>
					{/* <Route
						path="approved-adverts"
						element={
							<ProtectedRoute isAllowed={isAllowed}>
								<ApprovedAdverts />
							</ProtectedRoute>
						}
					/>
					<Route
						path="paid-adverts"
						element={
							<ProtectedRoute isAllowed={isAllowed}>
								<PaidAdvert />
							</ProtectedRoute>
						}
					/> */}
					<Route
						path="change-password"
						element={
							<Suspense fallback={<SpinLoader />}>
								<ProtectedRoute isAllowed={isAllowed}>
									<ChangePassword />
								</ProtectedRoute>
							</Suspense>
						}
					/>
					<Route
						path="notifications"
						element={
							<Suspense fallback={<SpinLoader />}>
								<ProtectedRoute isAllowed={isAllowed}>
									<Notifications />
								</ProtectedRoute>
							</Suspense>
						}
					/>
					<Route
						path="new-advert"
						element={
							<Suspense fallback={<SpinLoader />}>
								<ProtectedRoute isAllowed={isAllowed}>
									<NewAdvert />
								</ProtectedRoute>
							</Suspense>
						}
					/>
					<Route
						path="update-profile"
						element={
							<Suspense fallback={<SpinLoader />}>
								<ProtectedRoute isAllowed={isAllowed}>
									<ProfileUpdate />
								</ProtectedRoute>
							</Suspense>
						}
					/>
					<Route
						path="my-profile"
						element={
							<Suspense fallback={<SpinLoader />}>
								<ProtectedRoute isAllowed={isAllowed}>
									<MyProfile />
								</ProtectedRoute>
							</Suspense>
						}
					/>
				</Route>
				<Route
					path="/payment/callback/:advertID/:channel"
					element={
						<Suspense fallback={<SpinLoader />}>
							<ProtectedRoute isAllowed={isAllowed}>
								<AdvertCallback />
							</ProtectedRoute>
						</Suspense>
					}
				/>

				<Route path="*" element={<NotFound />} />
			</Routes>
		</AnimatePresence>
	);
};

export default BaseRoute;
